"use strict";
// This is just a copy of vendor/javfres/laravel-jslang/src/ts-interface/jslang
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSLang = exports.trans_choice = exports.trans = exports.getJSLangInstance = void 0;
function getJSLangInstance() {
    if (!window.JSLang) {
        console.error("JSLang was not loaded");
        throw new Error("JSLang was not loaded");
    }
    const JSLang = window.JSLang;
    return JSLang;
}
exports.getJSLangInstance = getJSLangInstance;
function trans(key, replaces) {
    try {
        return getJSLangInstance().trans(key, replaces);
    }
    catch (e) {
        return key;
    }
}
exports.trans = trans;
function trans_choice(key, choice, replaces) {
    try {
        return getJSLangInstance().trans_choice(key, choice, replaces);
    }
    catch (e) {
        return key;
    }
}
exports.trans_choice = trans_choice;
exports.JSLang = getJSLangInstance();
